export default __webpack_public_path__ + "static/media/link_game.023fa4a1.jpg";